import { Component, computed, input } from '@angular/core';

import { BillType } from '../../models';
import { CommodityType } from '../../../zentility/_shared/_zen-legacy-common/_models/commodity';

/**
 * "Utility" / "Supplier" badge. When the bill's commodity is known the badge leads
 * with that commodity's icon in the dashboard header's colours (bolt on yellow for
 * electricity, flame on blue for gas), so a row's commodity is readable at a glance
 * without a dedicated column.
 */
@Component({
  selector: 'app-bill-type-badge',
  standalone: true,
  imports: [],
  template: `
    @if (type() === 'utility' || type() === 'supplier') {
      <div class="badge" [class.utility]="type() === 'utility'" [class.supplier]="type() === 'supplier'" [title]="title()">
        @switch (commodity()) {
          @case (CommodityType.Electricity) {
            <i class="material-symbols-rounded commodity electric">bolt</i>
          }
          @case (CommodityType.Gas) {
            <i class="material-symbols-rounded commodity gas">local_fire_department</i>
          }
          @default {
            <i class="material-symbols-rounded">{{ type() === 'utility' ? 'power' : 'lightbulb' }}</i>
          }
        }
        <span>{{ type() === 'utility' ? 'Utility' : 'Supplier' }}</span>
      </div>
    }
    `,
  styleUrl: './bill-type-badge.component.scss'
})
export class BillTypeBadgeComponent {
    readonly CommodityType = CommodityType;

    readonly type = input<BillType>('unknown');
    readonly commodity = input<CommodityType | undefined>(undefined);

    readonly title = computed(() => {
        const typeLabel = this.type() === 'utility'
            ? 'Utility Bill (Distribution + Supply)'
            : 'Supplier Bill (Supply Only)';
        switch (this.commodity()) {
            case CommodityType.Electricity: return `Electricity · ${typeLabel}`;
            case CommodityType.Gas: return `Natural Gas · ${typeLabel}`;
            default: return typeLabel;
        }
    });
}
